import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FUNCTIONAL_ROLES_URL,
  ROLES_UPDATE_URL,
  ROLES_URL,
  USERS_URL,
} from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import { useAlert } from "./../../alerts/AlertContext";
import AddTaskIcon from "@mui/icons-material/AddTask";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function RolesDialog({ roleId, selectedRoleName, callRoles, isEdit }) {
  const [open, setOpen] = React.useState(false);
  const [roleName, setRoleName] = useState("");
  const [desc, setDesc] = useState("");

  const [owner, setOwner] = useState();
  const [owners, setOwners] = useState([]);

  const [functionalRole, setFunctionalRole] = useState("");
  const [functionalRoles, setFunctionalRoles] = useState([]);
  const showAlert = useAlert();

  const handleClickOpen = async () => {
    getUsers();
    getFunctionalRoles();
    if (isEdit) {
      getRole();
    } else {
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleRoleNameChange = (event) => {
    setRoleName(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleOwnerChange = (event) => {
    setOwner(event.target.value);
  };

  const handleFunctionalRoleChange = (event) => {
    setFunctionalRole(event.target.value);
  };

  const getUsers = () => {
    AxiosInstance.get(USERS_URL).then((response) => setOwners(response.data.data));
  };

  const getFunctionalRoles = () => {
    AxiosInstance.get(FUNCTIONAL_ROLES_URL).then((response) =>
      setFunctionalRoles(response.data)
    );
  };

  const getRole = async () => {
    await AxiosInstance.get(`${ROLES_URL}/${roleId}`).then((response) => {
      var roleData = response.data.data;
      setRoleName(roleData.name);
      setOwner(roleData.owner.id);
      setFunctionalRole(roleData.functionalRole.id);
      setDesc(roleData.description);
      setOpen(true);
    });
  };

  const handleSave = () => {
    const payload = {};
    payload.name = roleName;
    payload.owner = { id: owner };
    payload.description = desc;
    payload.functionalRole = { id: functionalRole };

    if (isEdit) {
      updateRole(payload);
    } else {
      saveRole(payload);
    }
  };


  const saveRole = async (payload) => {
    await AxiosInstance.post(ROLES_URL, payload)
      .then((response) => {
        showAlert("Role created successfully!", "success");
        callRoles();
      })
      .catch((error) => {
        showAlert("Role creation failed!", "error");
        console.error(error);
      });
  };

  const updateRole = async (payload) => {
    await AxiosInstance.put(`${ROLES_URL}/${roleId}`, payload)
      .then((response) => {
        showAlert("Role updated successfully!", "success");
        callRoles();
      })
      .catch((error) => {
        showAlert("Role updation failed!", "error");
        console.error(error);
      });
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {roleId === 0 ? (
          <>
          {/* <Button
              variant="outlined"
              onClick={handleClickOpen}
              style={{ float: "right", margin: "5px" }}
            >
              Add Role
            </Button> */}
          < Tooltip
              title= "Add Role"
              onClick={handleClickOpen}
        style={{ cursor: "pointer", margin: "2px", float: "right" }}
        >
              <IconButton>
          <AddTaskIcon color="primary" />
        </IconButton>
            </Tooltip>
          </>
  ) : (
    <Link onClick={handleClickOpen}>{selectedRoleName}</Link>
  )
}
{/* <Button variant="outlined" onClick={handleClickOpen} style={{float:"right", margin:"5px"}}>
                    {(roleId===0)?'Add Role':'Edit Role'}
                </Button> */}

<Dialog
  open={open}
  onClose={handleClose}
  PaperProps={{
    component: "form",
    onSubmit: (event) => {
      event.preventDefault();
      handleSave();
      handleClose();
    },
  }}
>
  <DialogTitle>{roleId === 0 ? "Add Role" : "Edit Role"}</DialogTitle>
  <DialogContent>
    <Box
      component="form"
      sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
      noValidate
      autoComplete="off"
    >
      <TextField
        autoFocus
        required
        margin="dense"
        id="rg"
        name="name"
        label="Role Name"
        type="text"
        fullWidth
        variant="outlined"
        value={roleName}
        onChange={handleRoleNameChange}
      />

      <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
        <InputLabel id="demo-simple-select-standard-label">
          Functional Role
                </InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          onChange={handleFunctionalRoleChange}
          label="Functional Role"
          value={functionalRole}
        >
          <MenuItem value="">
            {" "}
            <em>None </em>{" "}
          </MenuItem>
          {functionalRoles.map((fr) => (
            <MenuItem value={fr.id}>{fr.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" sx={{ m: 1, minWidth: 200 }}>
        <InputLabel id="demo-simple-select-standard-label">
          Owner
                </InputLabel>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={owner}
          onChange={handleOwnerChange}
          label="Owner"
        >
          <MenuItem value="">
            {" "}
            <em>None </em>{" "}
          </MenuItem>
          {owners.map((ow) => (
            <MenuItem value={ow.id}>{ow.name}</MenuItem>
          ))}
        </Select>
      </FormControl>

      <TextField
        autoFocus
        id="outlined-multiline-static"
        name="description"
        label="Description"
        placeholder="Enter Description"
        fullWidth
        multiline
        rows={4}
        cols={10}
        value={desc}
        onChange={handleDescriptionChange}
        slotProps={{
          input: {
            sx: {
              display: "inline-table",
            },
          },
          htmlInput: {
            sx: {
              display: "inline-table",
            },
          },
        }}
      />
    </Box>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleClose}>Cancel</Button>
    <Button type="submit">Add </Button>
  </DialogActions>
</Dialog>
      </React.Fragment >
    </ThemeProvider >
  );
}
export default RolesDialog;
